<!-- /* [MATCH-ACCEPT-C-POP] 승인서 작성(기업) */ -->

<template>
  <div v-if="matchPeople">
    <BasicModal
      :isShowModal="isModal"
      @close-modal="$store.commit('directMatching/setHideModalPopup')"
      title="승인서 작성"
      disabledFooter
    >
      <div class="popupViewProfile">
        <CorpInfoCard
          v-if="matchPeople.roleName == $role.CORP"
          :data="matchPeople"
        />
        <UserInfoCard
          v-else-if="matchPeople.roleName == $role.USER"
          :data="matchPeople"
        />

        <section>
          <h3 class="matchingHeadLine">승인서 작성</h3>
          <ValidationObserver v-slot="{ handleSubmit }" class="aRow5">
            <form
              class="infoBoxForm"
              @submit.prevent="handleSubmit(onClickSubmitForm)"
            >
              <div style="margin-bottom: 50px;">
                <LabelInput
                  label="연락 담당자 이름"
                  :value="selfAccount.name"
                />
                <LabelInput label="이메일 주소" :value="selfAccount.email" />
                <LabelInput label="전화번호" :value="selfAccount.phoneNumber" />
                <ValidationProvider
                  name="전달 내용"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    v-model="form.responseReason"
                    label="전달 내용"
                    :errors="errors"
                  />
                </ValidationProvider>
              </div>

              <div class="modal-action">
                <MainButton
                  btnText="승인서 전송"
                  type="submit"
                  :disabled="disabledSubmit"
                />
              </div>
            </form>
          </ValidationObserver>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import TextAreaInputField from "@/components/formControl/TextAreaInputField.vue";
import { mapActions } from "vuex";
import CorpInfoCard from "@/components/items/CorpInfoCard.vue";
import UserInfoCard from "@/components/items/UserInfoCard.vue";
import matchingPopupMixins from "@/mixins/matching-popup-mixins";
import LabelInput from "@/components/formControl/LabelInput.vue";

export default {
  name: "DirectMatchAcceptCPopup",
  components: {
    BasicModal,
    MainButton,
    ValidationObserver,
    ValidationProvider,
    TextAreaInputField,
    CorpInfoCard,
    UserInfoCard,
    LabelInput,
  },
  mixins: [matchingPopupMixins],
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
  },
  data() {
    return {
      disabledSubmit: false,
      form: {},
    };
  },
  methods: {
    ...mapActions("directMatching", ["approveDirectMatching"]),
    onClickSubmitForm() {
      this.disabledSubmit = true;
      this.approveDirectMatching({
        requestId: this.selectedDirectMatching.idx,
        responseReason: this.form.responseReason,
      })
        .then((res) => {
          this.$store.commit("matching/replaceMatchingItem", res.data);
        })
        .finally(() => {
          this.disabledSubmit = false;
          this.$store.commit("directMatching/setHideModalPopup");
        });
    },
  },
  watch: {
    isModal(val) {
      if (!val) this.form = {};
    },
    "selectedDirectMatching.responseReason": {
      handler(val) {
        this.form.responseReason = val;
      },
    },
  },
};
</script>
